// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608270734/js/" + chunkId + "." + {"44":"31921c88","225":"0b73dca3","481":"e79bacf6","486":"7781b8a6","770":"8e556613"}[chunkId] + ".0.8961060216479522.chunk.js";
};